import React, {useMemo, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';

import {useCookies} from 'react-cookie';
import DotsLoading from '../../../components/dotsLoading';
import CustomSearchBox from '../../../components/mazraeKit/customSearchBox';
import {useGetInputGroupList} from '../../../services/hookService';
import useGetInputLists from '../../../services/hookService/getInputLists/useGetInputLists';
import {groupByField} from '../../../utilities/helper/groupByField';
import CategoryItem from './categoryItem';

const CategoriesPage = () => {
  const navigate = useNavigate();
  const {inputGroupList, isLoading} = useGetInputGroupList();
  const [, , removeCookie] = useCookies(['filter_farm']);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    navigate('/search-store', {state: {searchValue: e.target.value}});
    removeCookie('filter_farm');
  };
  const [inputValue, setInputValue] = useState('');

  const {data: Allinputlists} = useGetInputLists({enabled: true});

  const groupList = useMemo(() => {
    return groupByField(Allinputlists as IInputLists[], 'input_group.code');
  }, [Allinputlists]);

  return (
    <div className="flex flex-col gap-2 justify-between w-full h-full">
      <CustomHeader
        preIcon="icon-nameArrow---Right"
        isActiveRightIcon
        title="فروشگاه مزرعه"
        backRoute="/home"
        postComponent={() => (
          <i
            className={`text-gray-700 icon-namechat text-[25px]`}
            onClick={() => navigate('/my-chats')}
          />
        )}
      />

      <section className="flex overflow-y-auto flex-col gap-3 py-3 w-full h-full">
        <div className="flex px-3 w-full">
          <CustomSearchBox
            placeholder="جستجو در فروشگاه "
            type="text"
            value={''}
            inputCustomClass="pr-1"
            isFloating={true}
            preIcon="icon-nameSearch"
            onChange={onChangeHandler}
            isAutofcus={true}
            {...{inputValue, setInputValue}}
          />
        </div>

        {isLoading ? (
          <DotsLoading />
        ) : (
          <>
            {inputGroupList?.map(item => (
              <React.Fragment key={item.guid}>
                {item.code in itemConvertor && (
                  <CategoryItem
                    code={item.code}
                    inputListData={groupList?.[item.code] || []}
                    icon={itemConvertor[item.code].icon}
                    targetRoute={itemConvertor[item.code].name}
                    title={item.title}
                  />
                )}
              </React.Fragment>
            ))}
          </>
        )}
      </section>
      <MainFooter />
    </div>
  );
};

export default CategoriesPage;

export interface IItemConvertor {
  icon: string;
  route: string;
  name: string;
}
export const itemConvertor: Record<number, IItemConvertor> = {
  11: {
    icon: 'icon-namelab-fertlizerpesticide',
    route: 'fertilizer',
    name: 'fertilizer',
  },
  12: {icon: 'icon-namepesticide', route: 'pesticide', name: 'pesticide'},
  13: {icon: 'icon-nameseedseedling', route: 'seed', name: 'seed'},
  14: {icon: 'icon-nameagriculture-work', route: 'employee', name: 'employee'},
  15: {icon: 'icon-namemachine', route: 'machinery', name: 'machinery'},
  16: {
    icon: 'icon-nametoolsequipment',
    route: 'tool',
    name: 'tool',
  },
  17: {icon: 'icon-namefarmwater', route: 'farm', name: 'farm'},
  18: {icon: 'icon-namelaboratory', route: 'lab', name: 'lab'},
  19: {icon: 'icon-namemachine', route: 'tool', name: 'tool'},
};
